import { render } from "./clinic-dashboard.vue?vue&type=template&id=15a19f19&scoped=true"
import script from "./clinic-dashboard.vue?vue&type=script&lang=js"
export * from "./clinic-dashboard.vue?vue&type=script&lang=js"

import "./clinic-dashboard.vue?vue&type=style&index=0&id=15a19f19&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a19f19"]])

export default __exports__